import {
  RequirementConditionOperator,
  RequirementConditionType
} from 'generated-graphql/types';
import { AutomationFormItem } from 'modules/analyse/types/AutomationFormItem';

export const normalizeBetweenScoreConditions = (
  tasks: AutomationFormItem[]
): AutomationFormItem[] =>
  tasks.map((task) => ({
    ...task,
    requirementConditions: task.requirementConditions.map((condition) => {
      if (
        condition.type === RequirementConditionType.CandidateScoreCondition &&
        condition.operator === RequirementConditionOperator.Between &&
        condition.scoreScaled != null &&
        condition.scoreScaledMax != null &&
        condition.scoreScaled > condition.scoreScaledMax
      ) {
        return {
          ...condition,
          scoreScaled: condition.scoreScaledMax,
          scoreScaledMax: condition.scoreScaled
        };
      }
      return condition;
    })
  }));
